var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { TreatmentLabel } from '@/models/TreatmentLabel';
import { excludeRoles } from '@/support/ExcludeRoles';
import ErrorHandler from '@/support/ErrorHandler';
import { Setting as SettingModel } from '@/models/Setting';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { cloneDeep } from 'lodash';
import AddPlanStatusDialog from '@/components/AddPlanStatusDialog/AddPlanStatusDialog';
import { StudentDocumentStatus } from '@/models/StudentDocumentStatus';
import { RolesEnum } from '@/items/Roles';
let SchoolSettings = class SchoolSettings extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        // protected statusLabels: Label[] = [];
        this.isAddingPlanStatus = false;
        this.planStatuses = [];
        this.isLoadingPlanStatuses = true;
        this.treatmentLabelsLoaded = false;
        this.thisIsMeSettings = [];
        this.thisIsMeSettingsClone = [];
        this.thisIsMeSettingsLoaded = false;
        this.treatmentLabels = [];
        this.isEditingVersion = false;
        this.parnassysNumber = null;
        this.parnassysNumberClone = new SettingModel();
        this.isEdittingParnassys = false;
        this.isEdittingPlp = false;
        this.prioritySubjectsLabelSetting = '';
        this.versions = [
            // { value: '1' || 1, text: 'Mijnleerlijn' }, // versie 1
            // { value: '4' || 4, text: 'Portfolio blokken' }, // versie 2a
            { value: '2' || 2, text: 'Portfolio periode' },
            { value: '3' || 3, text: 'Rooster' },
        ];
        this.mailSettings = [
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'has_roster',
                        value: true,
                    },
                ]
                : []),
        ];
        this.guardianSettings = [
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_scooltracker',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_this_is_me',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_portfolio',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_finished',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_profile',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_notes',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('3')
                ? [
                    {
                        key: 'guardian_can_see_student_roster',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('2') || this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_use_chat_functions',
                        value: false,
                    },
                ]
                : []),
            ...(this.isVersion('3') || this.isVersion('4')
                ? [
                    {
                        key: 'guardian_can_see_student_lvs',
                        value: false,
                    },
                ]
                : []),
        ];
        this.parnassysSettings = {};
        this.parnassysSettingsClone = {};
        this.mfaSettings = {};
        this.mfaSettingsClone = {};
        this.version = {};
        this.studentSettings = {
            student_can_set_goal_to_yellow: false,
        };
        this.scoolSettings = {
            hide_my_roster: false,
        };
    }
    get exclude() {
        if (!this.user) {
            return true;
        }
        return excludeRoles[this.$store.state.version].scoolAdmin.schools.settings.version.includes(this.$store.state.Auth.roles[0].id);
    }
    get versionValue() {
        return this.versions.find((version) => {
            return version.value == this.$store.state.version;
        });
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    get canSeeParnassys() {
        if (!this.user) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get canSeeMfa() {
        if (!this.user) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.TRAINER]);
    }
    get dialogOptionsVersion() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.switchedVersion', { version: this.version.text }).toString(),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        window.location.reload();
                    },
                },
            },
        };
    }
    parseSettings() {
        const studentCanEditGoalToYellow = this.getSetting('student_can_set_goal_to_yellow');
        const hideMyRoster = this.getSetting('hide_my_roster');
        if (hideMyRoster) {
            this.scoolSettings.hide_my_roster = hideMyRoster.value;
        }
        const setting = this.getSetting('priority_subjects_label');
        this.mailSettings.forEach((mailSetting) => {
            if (mailSetting.key === undefined) {
                return;
            }
            const currentSetting = this.$store.state.settings.find((setting) => {
                return setting.key === mailSetting.key;
            });
            if (currentSetting) {
                mailSetting.value = currentSetting.value === '1' || currentSetting.value === true ? true : false;
            }
        });
        this.guardianSettings.forEach((guardianSetting) => {
            if (guardianSetting.key === undefined) {
                return;
            }
            const currentSetting = this.$store.state.settings.find((setting) => {
                return setting.key === guardianSetting.key;
            });
            if (currentSetting) {
                guardianSetting.value = currentSetting.value === '1' || currentSetting.value === true ? true : false;
            }
        });
    }
    mounted() {
        this.initialize();
    }
    destroyed() {
        this.fetchSettings();
    }
    async initialize() {
        this.isLoading = true;
        this.fetchPlanStatuses();
        this.fetchParnassysSettings();
        this.fetchMfaSettings();
        this.fetchPrioritySubjectsLabelSetting();
        this.parseSettings();
        this.fetchSchoolVersion();
        // this.fetchLabels();
        this.fetchTreatmentLabels();
        this.fetchThisIsMeSettings();
        this.isLoading = false;
    }
    fetchPrioritySubjectsLabelSetting() {
        const setting = this.getSetting('priority_subjects_label');
        if (!setting) {
            // we set a default value if it doesn't have one
            this.updateSettings('priority_subjects_label', 'MijnVoorrang');
            this.prioritySubjectsLabelSetting = 'MijnVoorrang';
        }
        else {
            this.prioritySubjectsLabelSetting = setting.value;
        }
    }
    parseParnassysSettings(key, setting) {
        if (!setting) {
            return null;
        }
        if (key === 'parnassys_brinnummer') {
            return setting.value;
        }
        return this.convertToBoolean(setting.value);
    }
    convertToBoolean(value) {
        return value === '1' || value === 1 || value === true;
    }
    fetchParnassysSettings() {
        const settingsKeys = [ParnassysSettings.PARNASSYS_BRINNUMMER, ParnassysSettings.PARNASSYS_SYNC_GUARDIANS, ParnassysSettings.PARNASSYS_SYNC_TEACHERS, ParnassysSettings.PARNASSYS_AUTO_SYNC_TEACHERS, ParnassysSettings.PARNASSYS_AUTO_SYNC_GUARDIANS, ParnassysSettings.PARNASSYS_AUTO_SYNC_STUDENTS];
        settingsKeys.forEach((key) => {
            const setting = this.$store.getters.getSetting(key);
            const parsedSetting = this.parseParnassysSettings(key, setting);
            if (typeof parsedSetting === 'boolean') {
                this.parnassysSettings[key] = parsedSetting;
            }
            if (typeof parsedSetting === 'string') {
                this.parnassysSettings[key] = parsedSetting;
            }
            if (parsedSetting === null) {
                // Prefill
                this.parnassysSettings[key] = null;
            }
        });
        this.parnassysSettingsClone = cloneDeep(this.parnassysSettings);
    }
    fetchMfaSettings() {
        const settingsKey = ['mfa_teachers', 'mfa_students', 'mfa_guardians'];
        settingsKey.forEach((key) => {
            const foundSetting = this.$store.getters.getSetting(key);
            if (foundSetting) {
                const convertedSetting = {
                    ...foundSetting,
                    value: foundSetting.value === '1' || foundSetting.value === 1 || foundSetting.value === true,
                };
                this.$set(this.mfaSettings, key, convertedSetting);
            }
            else {
                this.$set(this.mfaSettings, key, {
                    value: false,
                });
            }
        });
        this.mfaSettingsClone = cloneDeep(this.mfaSettings);
    }
    getSetting(key) {
        return this.$store.getters.getSetting(key);
    }
    async fetchSettings() {
        /*
        TODO: @Stefano this is called on component.destroyed. Refetching Settings; so that
                  switches displayed correctly when switching between tabs.
                  Might cause issues - was not in the original code - as, there was no tab switching.
        */
        const settings = await new SettingModel().limit(200).all();
        this.$store.dispatch('loadedSettings', settings);
    }
    isVersion(version) {
        return version == this.$store.state.version;
    }
    fetchTreatmentLabels() {
        this.treatmentLabelsLoaded = false;
        new TreatmentLabel().all().then((treatmentLabels) => {
            this.$store.dispatch('loadedTreatmentLabels', treatmentLabels);
            this.treatmentLabels = [];
            Object.keys(this.$t('idp.treatment')).forEach((treatment) => {
                const setting = this.$store.state.treatment_labels.find((label) => {
                    return label.key === treatment;
                });
                if (setting) {
                    setting.editing = false;
                    this.treatmentLabels.push(setting);
                }
                else {
                    this.treatmentLabels.push(new TreatmentLabel({ key: treatment, value: '', editing: false }));
                }
            });
            this.treatmentLabelsLoaded = true;
        });
    }
    onClickUpdatePrioSubjectLabel() {
        this.updateSettings('priority_subjects_label', this.prioritySubjectsLabelSetting);
        this.isEdittingPlp = false;
    }
    updateSettings(key, value) {
        const payload = { key, value };
        if (['mfa_teachers', 'mfa_students', 'mfa_guardians'].includes(key)) {
            payload.cast = 'boolean';
        }
        new SettingModel()
            .update([payload])
            .then(async (settings) => {
            await this.fetchSettings();
            if (key in this.parnassysSettings) {
                // console.log('HERE');
                this.fetchParnassysSettings();
                this.isEdittingParnassys = false;
            }
            // Refresh MFA settings to ensure UI updates
            if (key in this.mfaSettings) {
                this.fetchMfaSettings();
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    addPlanStatus() {
        this.isAddingPlanStatus = true;
    }
    async fetchPlanStatuses() {
        this.isLoadingPlanStatuses = true;
        this.planStatuses = await new StudentDocumentStatus().all();
        this.isLoadingPlanStatuses = false;
    }
    async deletePlanStatus(index) {
        const planStatus = this.planStatuses[index];
        try {
            await planStatus.delete();
            await this.fetchPlanStatuses();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    getThisIsMeSettingLabel(key) {
        switch (key) {
            case ThisIsMeSetting.PORTFOLIO_THIS_IS_ME_LABEL:
                return this.$tc('This is me label');
            case ThisIsMeSetting.PORTFOLIO_THIS_IS_YOU_LABEL:
                return this.$tc('This is you label');
            case ThisIsMeSetting.PORTFOLIO_PHOTO_ALBUM_LABEL:
                return this.$tc('Photo album label');
            case ThisIsMeSetting.PORTFOLIO_STUDENT_LABEL:
                return this.$tc('Student label');
            case ThisIsMeSetting.PORTFOLIO_TEACHER_LABEL:
                return this.$tc('Teacher label');
            case ThisIsMeSetting.PORTFOLIO_PARENT_LABEL:
                return this.$tc('Parent label');
            default:
                return key;
        }
    }
    onEditThisIsMeSetting(setting) {
        this.$set(setting, 'editing', true);
    }
    onCancelEditThisIsMeSetting(setting) {
        const clonedSetting = this.thisIsMeSettingsClone.find((s) => s.key === setting.key);
        if (clonedSetting) {
            this.$set(setting, 'value', clonedSetting.value);
        }
        setting.editing = false;
    }
    async updateThisIsMeSetting(setting) {
        try {
            await new SettingModel().update([
                {
                    key: setting.key,
                    value: setting.value,
                },
            ]);
            setting.editing = false;
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    updateTreatmentLabel(treatmentLabel) {
        const value = !treatmentLabel.value ? treatmentLabel.key : treatmentLabel.value;
        new TreatmentLabel()
            .updateTreamentLabels([{ key: treatmentLabel.key ? treatmentLabel.key : treatmentLabel.value, value: value || '' }])
            .then(() => {
            this.fetchTreatmentLabels();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    updateVersion(version) {
        const payload = {
            key: 'scool_version',
            value: version.value,
        };
        new SettingModel()
            .update([payload])
            .then((setting) => {
            this.$store.dispatch('loadedVersion', version.value);
            this.$store.dispatch('openDialog', this.dialogOptionsVersion);
            this.isEditingVersion = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    async fetchThisIsMeSettings() {
        this.thisIsMeSettingsLoaded = false;
        try {
            this.thisIsMeSettings = this.$store.state.settings.filter((setting) => {
                return setting.key && setting.key.startsWith('portfolio_');
            });
            this.thisIsMeSettings.forEach((setting) => {
                this.$set(setting, 'editing', false);
            });
            this.thisIsMeSettingsClone = cloneDeep(this.thisIsMeSettings);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.thisIsMeSettingsLoaded = true;
        }
    }
    fetchSchoolVersion() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'scool_version';
        });
        return (this.version = {
            value: setting ? setting.value : 3,
            text: setting ? setting.value.toString() : '3',
        });
    }
    get canEditBrinNumber() {
        if (!this.user) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT]);
    }
    get canSeeBrinNumber() {
        if (!this.user) {
            return false;
        }
        if (this.isTeacherWithExpertRights) {
            return true;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]);
    }
    get isParnassysDisabled() {
        return !this.$store.state.Auth.hasRole([RolesEnum.ROOT]) && !this.isTeacherWithExpertRights;
    }
};
SchoolSettings = __decorate([
    Component({
        components: {
            PageHeader,
            LoaderCard,
            AddPlanStatusDialog,
        },
    })
], SchoolSettings);
export default SchoolSettings;
export var ThisIsMeSetting;
(function (ThisIsMeSetting) {
    ThisIsMeSetting["PORTFOLIO_THIS_IS_ME_LABEL"] = "portfolio_this_is_me_label";
    ThisIsMeSetting["PORTFOLIO_THIS_IS_YOU_LABEL"] = "portfolio_this_is_you_label";
    ThisIsMeSetting["PORTFOLIO_PHOTO_ALBUM_LABEL"] = "portfolio_photo_album_label";
    ThisIsMeSetting["PORTFOLIO_STUDENT_LABEL"] = "portfolio_student_label";
    ThisIsMeSetting["PORTFOLIO_TEACHER_LABEL"] = "portfolio_teacher_label";
    ThisIsMeSetting["PORTFOLIO_PARENT_LABEL"] = "portfolio_parent_label";
})(ThisIsMeSetting || (ThisIsMeSetting = {}));
var ParnassysSettings;
(function (ParnassysSettings) {
    ParnassysSettings["PARNASSYS_BRINNUMMER"] = "parnassys_brinnummer";
    ParnassysSettings["PARNASSYS_SYNC_GUARDIANS"] = "parnassys_sync_guardians";
    ParnassysSettings["PARNASSYS_SYNC_TEACHERS"] = "parnassys_sync_teachers";
    ParnassysSettings["PARNASSYS_AUTO_SYNC_TEACHERS"] = "parnassys_auto_sync_teachers";
    ParnassysSettings["PARNASSYS_AUTO_SYNC_GUARDIANS"] = "parnassys_auto_sync_guardians";
    ParnassysSettings["PARNASSYS_AUTO_SYNC_STUDENTS"] = "parnassys_auto_sync_students";
})(ParnassysSettings || (ParnassysSettings = {}));
